import { restoreScrollTarget } from "@/lib/utils/scrollRestoration";
import { useEffect } from "react";

export function useScrollRestoration(pageKey: string, isLoading: boolean) {
  useEffect(() => {
    if (isLoading) return;
    restoreScrollTarget(pageKey);
  }, [pageKey, isLoading]);
}
